import { ServiceMaker, methods, services } from "@/services";
import Api from '@/services/service-v2'

export const adminLogin = data =>
  ServiceMaker("/users/admin/login", methods.POST, services.nipige, data);

export const partnerLogin = data =>
  ServiceMaker("/users/partner/login", methods.POST, services.nipige, data);

export const createPartnerService = data =>
  ServiceMaker("/users/partner", methods.POST, services.nipige, data);

export const listTenant = () =>
  ServiceMaker("/users/tenant/filter", methods.GET, services.nipige);

export const getTenantListLite = () =>
  ServiceMaker(`/users/tenant/list-ids`, methods.GET, services.nipige);

export const updateTenant = (id, data) =>
  ServiceMaker(
    `/users/tenant/update-tenant/${id}`,
    methods.PUT,
    services.nipige,
    data
  );

export const getAdsCount = () =>
  ServiceMaker("/api/item/details/count", methods.GET, services.catalog);

export const createTenant = data =>
  ServiceMaker(`/users/tenant`, methods.POST, services.nipige, data);

export const listTenantSubAdmin = () =>
  ServiceMaker("/users/admin/list", methods.GET, services.nipige);

export const userToDelete = (payload) =>
  ServiceMaker(`/users/admin/delete/${payload}`, methods.DELETE, services.nipige);  

export const createTenantSubAdmin = data =>
  ServiceMaker(`/users/admin`, methods.POST, services.nipige, data);

export const updateTenantSubAdmin = (id, data) =>
  ServiceMaker(`/users/admin/update-profile/${id}`, methods.PUT, services.nipige, data);

export const fetchKYCListByTenant = Id =>
  ServiceMaker(`/users/tenant/list-kyc/${Id}`, methods.GET, services.nipige);

export const uploadKYCByTenant = data =>
  ServiceMaker(`/users/tenant/submit-kyc`, methods.POST, services.nipige, data);

export const uploadKYCByUser = data =>
  ServiceMaker(`/users/admin/submit-kyc`, methods.POST, services.nipige, data);

export const getAnalyticsConfig = () =>
  ServiceMaker(
    `/users/tenant/analytics`,
    methods.GET,
    services.nipige,
    null,
    false,
    true
  );

export const getTenantDetailByID = payload =>
  ServiceMaker(
    `/users/tenant/detail-by-id/${payload}`,
    methods.GET,
    services.nipige
  );

export const getTenantPreferences = payload =>
  ServiceMaker(
    `/users/tenant/get-preferences/${payload}`,
    methods.GET,
    services.nipige
  );

export const updateTenantPreferences = payload =>
  ServiceMaker(
    `/users/tenant/update-preferences/${payload.id}`,
    methods.POST,
    services.nipige,
    payload.data
  );

export const setPaymentConfig = payload =>
  ServiceMaker(
    `/payments/config/set/${payload.id}`,
    methods.POST,
    services.master,
    payload.data
  );

  export const getTenantAnalyticReport = (payload)=> Api().$http.post(`dashboard/analytic-report/filter`,payload)

  export const updateStatus = (id,payload)=> Api().$http.patch(`cap/users/admin/update-status/${id}`,payload)

  export const fetchKYCListByUser = (id)=> Api().$http.get(`cap/users/admin/list-kyc/${id}`)
